import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listArticles, type ArticleRow } from "../lib/api";
import EventsPage from "./EventsPage";
import ServiceHomePage from "./ServiceHomePage";
import { useSiteClub } from "../lib/SiteClubContext";

/** Front page: the upcoming-events preview (with a "more…" link out to the
 *  full /events list) followed by a full-width, title-less articles feed --
 *  reuses listArticles as-is, which already sorts featured articles first
 *  (same pattern as events), so "Featured" already does something here. */
export default function HomePage() {
  const { club, loading } = useSiteClub();
  if (loading) return null;
  // The RC Race HQ service site gets the platform landing page; a club's own
  // domain keeps its events + news front page.
  if (!club) return <ServiceHomePage />;
  return <ClubHomePage />;
}

function ClubHomePage() {
  const [articles, setArticles] = useState<ArticleRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listArticles()
      .then((res) => setArticles(res.articles))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load news."));
  }, []);

  return (
    <div>
      <EventsPage moreLinkTo="/events" />
      <div className="full-bleed" style={{ marginTop: "2rem" }}>
        {error && <p className="err">{error}</p>}
        {articles && articles.length > 0 && (
          <div className="events-grid single-column">
            {articles.map((a) => (
              <Link key={a.articleId} to={`/news/${a.articleId}`} className="card event-card">
                <h3>{a.title}</h3>
                <p className="muted">
                  {new Date(a.publishDate || a.createdAt).toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </p>
                {a.summary && <p>{a.summary}</p>}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
